import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { Formik, Form as FormikForm } from 'formik';
import Select from 'react-select';
import { FaUpload } from 'react-icons/fa';
import { toast } from 'react-toastify';

import {
  customStyles,
  DropdownIndicator,
} from '~/Styles/reactSelectStyles';
import { importarConciliacao } from '~/Services/Service';
import { importarSchema } from '../validationSchemas';
import { extrairMensagemErro } from '../helpers';

const HeaderUpload = ({ onImportado, disabled }) => {
  const empreendimentosRedux = useSelector((state) => state.empreendimentos);

  const options = useMemo(() => {
    const lista =
      empreendimentosRedux && empreendimentosRedux.sort
        ? empreendimentosRedux.sort
        : [];
    return lista.map((item) => ({
      value: item.codigo,
      label: `${item.codigo} - ${item.descricao}`,
    }));
  }, [empreendimentosRedux]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formData = new FormData();
      formData.append('file', values.arquivo);
      formData.append('ge', String(values.codigoGrupoEmpresa));

      const resposta = await importarConciliacao(formData);
      toast.success(
        `Arquivo ${values.arquivo.name} importado. ${
          resposta && resposta.total_movimentos != null
            ? `${resposta.total_movimentos} movimentos.`
            : ''
        }`
      );
      resetForm();
      if (onImportado) onImportado(resposta);
    } catch (err) {
      const mensagem = extrairMensagemErro(
        err,
        'Falha ao importar arquivo CNAB.'
      );
      toast.error(mensagem);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Importar arquivo CNAB240
      </Card.Header>
      <Card.Body>
        <Formik
          initialValues={{
            codigoGrupoEmpresa:
              options.length === 1 ? options[0].value : null,
            arquivo: null,
          }}
          enableReinitialize
          validationSchema={importarSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
          }) => (
            <FormikForm>
              <Row>
                <Col xs={12} md={5} className="mb-2">
                  <Form.Label className="small mb-1">
                    Empreendimento
                  </Form.Label>
                  <Select
                    options={options}
                    value={
                      options.find(
                        (o) => o.value === values.codigoGrupoEmpresa
                      ) || null
                    }
                    onChange={(opt) =>
                      setFieldValue(
                        'codigoGrupoEmpresa',
                        opt ? opt.value : null
                      )
                    }
                    onBlur={() => setFieldTouched('codigoGrupoEmpresa', true)}
                    isDisabled={disabled || isSubmitting}
                    placeholder="Selecione o empreendimento"
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    isClearable
                  />
                  {touched.codigoGrupoEmpresa && errors.codigoGrupoEmpresa && (
                    <div className="text-danger small mt-1">
                      {errors.codigoGrupoEmpresa}
                    </div>
                  )}
                </Col>
                <Col xs={12} md={5} className="mb-2">
                  <Form.Label className="small mb-1">
                    Arquivo CNAB240 (.txt, .cnab, .ret, .rem)
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept=".txt,.cnab,.ret,.rem"
                    isInvalid={touched.arquivo && !!errors.arquivo}
                    disabled={disabled || isSubmitting}
                    onChange={(e) => {
                      const file =
                        e.currentTarget.files && e.currentTarget.files[0]
                          ? e.currentTarget.files[0]
                          : null;
                      setFieldValue('arquivo', file);
                    }}
                  />
                  {touched.arquivo && errors.arquivo && (
                    <Form.Control.Feedback type="invalid">
                      {errors.arquivo}
                    </Form.Control.Feedback>
                  )}
                </Col>
                <Col
                  xs={12}
                  md={2}
                  className="mb-2 d-flex align-items-end"
                >
                  <Button
                    type="submit"
                    variant="primary"
                    disabled={disabled || isSubmitting}
                    className="w-100"
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mr-1"
                        />{' '}
                        Importando...
                      </>
                    ) : (
                      <>
                        <FaUpload className="mr-1" /> Importar
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </FormikForm>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default HeaderUpload;
